/* eslint-disable no-prototype-builtins */
/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// TODO: remove ts-nocheck
const create = (
  // eslint-disable-next-line @typescript-eslint/ban-types
  object: Object,
  form?: FormData,
  namespace?: string,
  stringify?: boolean,
): FormData => {
  const formData = form || new FormData();

  for (const property in object) {
    if (object.hasOwnProperty(property)) {
      const formKey = namespace ? `${namespace}[${property}]` : property;

      if (object[property] instanceof Date) {
        formData.append(formKey, object[property].toISOString());
      } else if (Array.isArray(object[property]) && object[property].length > 0) {
        for (let i = 0; i < object[property].length; i++) {
          formData.append(
            object[property][i] instanceof File ? property : `${property}[]`,
            object[property][i] instanceof File
              ? object[property][i]
              : JSON.stringify([object[property][i]]),
          );
        }
      } else if (
        typeof object[property] === 'object' &&
        object[property] instanceof Array &&
        object[property].length === 0
      ) {
        formData.append(formKey, '[]');
      } else if (
        typeof object[property] === 'object' &&
        !(object[property] instanceof File) &&
        !stringify
      ) {
        create(object[property], formData, formKey);
      } else if (typeof object[property] === 'object' && stringify) {
        formData.append(formKey, JSON.stringify(object[property]));
      } else if (typeof object[property] === 'string' && object[property].length === 0) {
        formData.append(formKey, String(null));
      } else if (object[property] !== undefined && object[property] !== null) {
        formData.append(formKey, object[property]);
      }
    }
  }

  return formData;
};

export const formData = {
  create,
};
